
export default {
    getRelayByIndex : function(device, index)
    {
        return (device.relays ? device.relays[index]:undefined);
    }
}
